module.exports = __webpack_public_path__ + "img/9_Middle Transverse Colon(and Transverse colon).19fe61f9.png";